<template>
  <div class="cp-section">
    <OrderList :input="input" :params="params" title="Order History" />
  </div>
</template>

<script>

import {FulfillmentStatus} from '@/constants'

const OrderList = () => import('./../Order/OrderList')

export default {
  name: 'CustomerPortalOrderHistory',
  components: {OrderList},
  props: {
    input: Object
  },
  data: function() {
    return {
      params: {
        is_active: false,
        fulfillment_status__in: [FulfillmentStatus.Cancelled, FulfillmentStatus.Delivered, FulfillmentStatus.Skipped, FulfillmentStatus.Removed].join(',')
      }
    }
  }
}
</script>

<style scoped>

</style>
